import gql from 'graphql-tag';

export const QUERY_LANDLORD = gql`
  query landlords(
    $nameLike: NonEmptyString
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
  ) {
    landlords(nameLike: $nameLike, pageSize: $pageSize, pageNumber: $pageNumber) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      edges {
        node {
          slug
          name
          id
          propertiesCount
        }
      }
    }
  }
`;
